const EGDSTextLoyaltyThemes = {
    LOW: 'lowtier',
    MID: 'midtier',
    HIGH: 'hightier',
    EXTRAHIGH: 'extrahightier',
    VIP: 'vip',
};

export { EGDSTextLoyaltyThemes };
//# sourceMappingURL=index.esm.js.map
